import React from 'react';
import DashboardIcon from '@mui/icons-material/Dashboard';
import { lazyPage } from '../lazyPage';

const Dashboard360Stats = lazyPage(() => import(/* webpackChunkName: "m-insights" */ '../../pages/Dashboard360Stats'));

/**
 * Insights module — the dashboard fragments (CRM_CONSOLIDATION_PLAN R3).
 *
 * No `insights` permission key exists in the permission store today: these pages
 * were previously routed with NO sidebar entry at all. Using a nonexistent
 * featureName means permission-scoped users don't see the group (unchanged
 * behavior) while null-permission admins/super-admins get sidebar links for the
 * first time — deliberate, per the wave-3 IA ("every current route maps").
 *
 * The former `/user-stats` route was removed (2026-07-17, QW2): it embedded a
 * public, unauthenticated, externally-editable Google Sheet — not app data.
 */
const insightsManifest = {
    id: 'insights',
    featureName: 'insights_mgmt',
    permission: 'view',
    routes: [
        { path: '/dashboard', element: <Dashboard360Stats /> },
    ],
    sidebarItems: [
        { text: '360 Dashboard', icon: <DashboardIcon />, link: '/dashboard' },
    ],
};

export default insightsManifest;
